import React, { useEffect, useState } from "react";

import {
	Backdrop,
	Box,
	Card,
	Checkbox,
	ClickAwayListener,
	Fade,
	FormControl,
	FormControlLabel,
	Grid,
	MenuItem,
	Modal,
	Radio,
	RadioGroup,
	Select,
	Stack,
	styled,
	Switch,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	ToggleButton,
	ToggleButtonGroup,
	Typography,
	CircularProgress
} from "@mui/material";
import Header from '../partials/header';
import LeftSidebar from '../partials/leftSidebar';
import { Image, Form as RBFORM } from 'react-bootstrap';
import ProfileAvatar from "./ProfileAvatar";
import phoneIcon from "../../assets/images/icon/phoneIcon.svg";
import mailIcon from "../../assets/images/icon/mailIcon.svg";
import closeIcon from "../../assets/images/icon/ckose.png";
// import dropArrow from "/public/icons/dropdownIcon.svg";
import { getMethod, postMethod, postMethodFormData } from "../../services/apiService";
import { forEachChild } from "typescript";
import "./Users.css";
// import InfoHoverTooltip from "../Tooltips/InfoHover";
import PhoneInput from "react-phone-input-2";
import { ToastContext, useToastContext } from "../../context/toastContext";
import { clearStorageAndCookies } from "../../services/authService";
import { useNavigate } from 'react-router-dom';
import { PROFILE_TYPE } from "../../helper/globalConstant";
// import UserCard from "./UserCard";
import { isValidPhoneNumber } from 'libphonenumber-js';
import InfoHoverTooltip from "../Tooltips/InfoHover";
import DownloadIcon from '@mui/icons-material/Download';



const AntSwitch = styled(Switch)(({ theme }) => ({
	width: 18,
	height: 11,
	padding: 0,
	display: "flex",
	"&:active": {
		"& .MuiSwitch-thumb": {
			width: "5px",
			height: "5px",
		},
	},
	"& .MuiSwitch-switchBase": {
		padding: 2,
		"&.Mui-checked": {
			transform: "translateX(8px)",
			color: "#1F2F34",
			"& + .MuiSwitch-track": {
				opacity: 1,
				backgroundColor: "#17B2EB",
				border: "1.32px solid #17B2EB",
			},
		},
	},
	"& .MuiSwitch-thumb": {
		width: "5px",
		height: "5px",
		margin: "1.3px 1px 0 1px",
		borderRadius: 6,
		boxShadow: "none",
		transition: theme.transitions.create(["width"], {
			duration: 300,
		}),
	},
	"& .MuiSwitch-track": {
		opacity: 1,
		backgroundColor: "transparent",
		boxSizing: "border-box",
		border: "1.32px solid var(--text-text-tertiary, #A5A8A9)",
		borderRadius: 16 / 2,
	},
}));

const ActivateAndSuspenduser = async (type: string, userId: string) => {
	const data = {
		userid: userId,
	}
	try {
		const response = await fetch(`/v-apiserver/REST/central/user/${type}`, {
			method: "POST",
			body: JSON.stringify(data),
			headers: {
				"Access-Control-Allow-Headers": "Cookie",
				"Content-Type": "application/json",
				// "Access-Control-Allow-Origin": "*",
				Cookie: document.cookie,
			},
		});
		const responseData = await response.json();
		return responseData;
	} catch (error) {
		console.log("API ERROR inside fetchAssignedSites", error);
	}
};


const UserManagement = () => {

	const { setToast } = useToastContext() as ToastContext;
	const navigate = useNavigate();

	interface User {
		centralUser: UserData;
	}

	interface UserData {
		userId: string;
		profileId: number;
		superadmin: boolean;
		name: string;
		lastName: string;
		address: Address;
		mailId: string;
		mobile: string;
		sequrityQuestion1?: string;
		sequrityAnswer1?: string;
		sequrityQuestion2?: string;
		sequrityAnswer2?: string;
		lastLoginTime: number;
		logedId: boolean;
		machineUser: number;
		sites: any[];
		enterprises: any[];
		accountStatus: string;
		profilePhoto: string;
	}

	interface Address {
		state: string;
	}

	interface FormData {
		name: string;
		lastName: string;
		mailId: string;
		mobile: string;
		//sites: string;
		role: string;
		profileId: string;
		emailMessage: string;
	}

	const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	const [errors, setErrors] = useState<Partial<FormData>>({});
	const validateForm = (data: any) => {
		let errors: Partial<FormData> = {};
		if (!data.name) {
			errors.name = "First name is required";
		}
		if (!data.lastName) {
			errors.lastName = "Last Name is required";
		}
		if (!data.mailId) {
			errors.mailId = "Email ID can't be empty";
		} else if (!emailPattern.test(data.mailId)) {
			errors.mailId = "Please provide correct email pattern";
		}
		if (!data.mobile) {
			errors.mobile = "Enter a valid mobile number";
			setPartnerMobileNumber("Enter a valid mobile number");
		}

		if (!data.emailMessage && actionType === "new") {
			errors.emailMessage = "Email message can't be empty";
		}
		return errors;
	};

	const [formData, setFormData] = useState({
		name: "",
		lastName: "",
		mailId: "",
		mobile: "",
		profileId: 0,
		emailMessage: "",
		redirecturl: "",
	});

	const handleChange = (e: any) => {
		const { name, value } = e.target;
		if (name === "name") {
			errors.name = "";
		} else if (name === "lastName") {
			errors.lastName = "";
		} else if (name === "mobile") {
			errors.mobile = "";
		} else if (name === "mailId") {
			if (!emailPattern.test(value)) {
				errors.mailId = "Please provide correct email pattern";
			} else {
				errors.mailId = "";
			}
		} else if (name === "emailMessage") {
			errors.emailMessage = "";
		} else if (name === "profile") {
			errors.emailMessage = "";
		}

		setFormData({ ...formData, [name]: value });

		// if (openModal2) {
		//   setEditFormData({ ...editFormData, [name]: value });
		// } else {
		//   setFormData({ ...formData, [name]: value });
		// }
	};
	const [setData, setUserData] = useState<User[]>([]);


	let getUsers = async () => {
		const apiEndpoint = `central/user/priority/${PROFILE_TYPE.INTEGRATOR}`
		const response = await getMethod(apiEndpoint);
		if (response.data.code === 200) {
			setUserData(response.data.result);
			localStorage.setItem("userData", JSON.stringify(response.result));
		} else {
			// handleErrorClick(response.message);
		}
		// setIsLoading(false);
	}

	const handleCloseModal = () => {
		//setNewSiteRole([]);
		setOpenModal1(false);
		// setOpenModal2(false);
		// setOpenModal3(false);
		//setSelectedSite("");
		// setSelectedRole("");
		// setDropdownVisible(null);
		// setRolesVisible(false);
		//setSitesVisible(false);
		// setchangeSite(0);
		setFormData({
			name: "",
			lastName: "",
			mailId: "",
			mobile: "",
			profileId: 0,
			emailMessage: "",
			redirecturl: "",
		});
		// setEditFormData({
		//   name: "",
		//   lastName: "",
		//   mailId: "",
		//   mobile: "",
		//   profileId: 0,
		//   userId: "",
		//   emailMessage: "",
		// });
		let errors: Partial<FormData> = {};
		setErrors(errors);
	};

	useEffect(() => {
		getUsers();
	}, []);

	useEffect(() => {
		console.log(setData)
	}, [setData])

	
	const handleChangeSwitch = (userId: string, type: string) => async (event: any) => {
		const checked = event.target.checked;

		try {
			const res = await ActivateAndSuspenduser(type, userId);

			if (res.code === 200) {
				// Only update UI on success
				const newData = [...setData];
				const userIndex = newData.findIndex(user => user.centralUser.userId === userId);

				newData[userIndex].centralUser.accountStatus = checked ? "ACTIVE" : "SUSPENDED";
				setUserData(newData);
				getUsers();
				setToast(res?.message, "success");
			} else {
				
				setToast(res?.message, "error");
			}
		} catch (error) {
			setToast("Something went wrong", "error");
		}
	};


	const [search, serSearch] = React.useState("");
	const handleSearch = (e: any) => {
		serSearch(e.target.value.toLowerCase());

		// let userData = JSON.parse(localStorage.getItem("userData")!);
		// let searchedData = setData.filter(
		// 	(item: any) => {
		// 		let fullName: any;
		// 		if (item.name && item.lastName) {
		// 			fullName = `${item.name} ${item.lastName}`.toLowerCase();
		// 		} else if (item.name) {
		// 			fullName = `${item.name}`.toLowerCase();
		// 		}
		// 		const searchTerm = e.target.value.toLowerCase();
		// 		return fullName.toLowerCase().includes(searchTerm) ||
		// 			item.mobile.includes(e.target.value) ||
		// 			item.mailId.toLowerCase().includes(searchTerm)
		// 	}
		// );
		// setUserData(searchedData);
	};
	const [openModal1, setOpenModal1] = React.useState(false);
	const [selectedUser, setSelectedUser] = useState<any>(null);
	const [actionType, setActionType] = useState("new");

	const handleOpenModal1 = (action_type: string, user: any) => {
		setActionType(action_type);
		setSelectedUser(user);
		setOpenModal1(true);
		if(action_type === "edit") {
			setFormData({
				name: user?.centralUser?.name,
				lastName: user?.centralUser?.lastName,
				mailId: user?.centralUser?.mailId,
				mobile: user?.centralUser?.mobile,
				profileId: 0,
				emailMessage: "",
				redirecturl: "",
			});
		}
	};

	const getHostFromUrl = async () => {
		try {
			const urlObject = new URL(window.location.href);
			const redirect_url = urlObject.protocol+"//"+urlObject.host+"/set-password?uk=";
			return redirect_url;
		} catch (error) {
			console.error('Invalid URL:', error);
			return null;
		}
	}

	const handleSubmit = async (e: any, type: string) => {
		e.preventDefault();
		if(partnerMobileNumber) return;

		var payload = {}
		if (type === "user") {
			const validationErrors = validateForm(formData);
			if (Object.keys(validationErrors).length > 0) {
				setErrors(validationErrors);
			} else {
				var apiEndpoint = "";
				var redirect_url = await getHostFromUrl();	
				if(actionType === "new") {		
					apiEndpoint = `partner/register`;	
					payload = {
						name: formData.name,
						lastName: formData.lastName,
						mailId: formData.mailId,
						mobile: formData.mobile,
						emailMessage: formData.emailMessage,
					}
					payload = { ...formData, mobile: `+${formData.mobile}`, profileId: PROFILE_TYPE.INTEGRATOR, redirecturl: redirect_url, };
				} else {
					apiEndpoint = `partner/update/${selectedUser?.userId}`;
					var form_data = new FormData();
					form_data.append("name", formData.name);
					form_data.append("lastname", formData.lastName);
					form_data.append("email", formData.mailId);
					form_data.append("mobile", formData.mobile.startsWith('+') ? formData.mobile : `+${formData.mobile}`);
					form_data.append("redirecturl", "/set-password?uk=");

					payload = form_data;
				}				
				
				var response;
				if(actionType === "new") response = await postMethod(apiEndpoint, payload)
				else response = await postMethodFormData(apiEndpoint, payload);
				
				if (response?.status === 200) {
					setToast("User updated successfully!", "success");
					setOpenModal1(false);
					getUsers();
					setFormData({
						name: "",
						lastName: "",
						mailId: "",
						mobile: "",
						profileId: 0,
						emailMessage: "",
						redirecturl: "",
					});
				} else {
					setToast(response?.data?.message, "error");
				}
			}
		}
		/* const apiEndpoint = `partner/register`
		const response = await postMethod(apiEndpoint, payload)
		console.log(response)
		if (response.status === 200) {
			setOpenModal1(false);
			getUsers();
			setFormData({
				name: "",
				lastName: "",
				mailId: "",
				mobile: "",
				profileId: 0,
				emailMessage: "",
				redirecturl: "",
			});
		} else {
			setToast(response?.data?.message, "error");
		} */
	};

	// MUI MODAL CSS
	const styleModal = {
		position: "absolute" as "absolute",
		top: "50%",
		left: "50%",
		transform: "translate(-50%, -50%)",
		minWidth: "650px",
		backgroundColor: "#1D292E",
		border: "1px solid #5A5F60",
		borderRadius: "32px",
		padding: "32px",
	};


	type PhoneNumberState = {
		number: string;
		error: string;
	};

	const [phoneNumber, setPhoneNumber] = useState<PhoneNumberState>({
		number: '',
		error: '',
	});




	const validatePhoneNumber = (phoneNumber: string) => {
		// This pattern allows an optional + followed by 10 to 15 digits, covering most international formats.
		const phonePattern = /^\+?\d{10,15}$/;

		if (!phonePattern.test(phoneNumber)) {
			setPhoneNumber((prev) => ({
				...prev,
				number: phoneNumber,
				error: 'Invalid phone number',
			}));
			setErrors((prev) => ({
				...prev,
				mobile: 'Invalid phone number',
			}));
		} else {
			setPhoneNumber((prev) => ({
				...prev,
				number: phoneNumber,
				error: '',
			}));
			setErrors((prev) => ({
				...prev,
				mobile: '',
			}));
		}
	};


	const handleNumber = (number: string, type: string) => {
		// setPhoneNumber(prev =>({...prev,number:`+${number}`}))
		if (type === "create") {
			setFormData({ ...formData, 'mobile': number });
			// } else {
			//   setEditFormData({ ...editFormData, 'mobile': number });
			// }
			//validatePhoneNumber(number)
		}
	}




	const breadCrumb = [
		{
		  label: "Admin",
		  path: "/admin",
		},
		{
		  label: "Partners",
		  path: "/admin/partner",
		},
	  ];


	const [partnerMobileNumber, setPartnerMobileNumber] = useState("");
	const validateMobileNumber = async (mobile_number: any) => {
		if (!mobile_number) {
			setPartnerMobileNumber("Enter a valid mobile number!");
			return;
		}

		if (mobile_number && !mobile_number.includes('+')) {
			mobile_number = `+${mobile_number}`;
		}

		const isValid = isValidPhoneNumber(mobile_number);

		if (!isValid) {
			setPartnerMobileNumber("Enter a valid mobile number!");
		} else {
			setPartnerMobileNumber("");
		}
	}


	const downloadLicense = async (partnerId: string) => {
		if (partnerId) {
			const resp = await getMethod(`partner/license/key/${partnerId}`);
			
			if (resp?.status === 200) {
				const url = window.URL.createObjectURL(new Blob([resp.data]));
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', `${partnerId}.key`);
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			}
		}
	}

	return (
		<>
			<Box sx={{ display: 'flex' }}>

				<Header title="" breadCrumb={breadCrumb}  />
				<LeftSidebar />
				<Box
					component="main"
					sx={{
						flexGrow: 1,
						p: 3,
						marginTop: 8,
						paddingRight: '20',
					}}
				>


					{/* HEADER  */}
					<Stack
						display="flex"
						flexDirection="row"
						alignItems="center"
						justifyContent="space-between"
						style={{ paddingBottom: "32px" }}
					>
						<div></div>
						<Stack
							display="flex"
							flexDirection="row"
							alignItems="center"
							gap="16px"
						>
							<div
								style={{
									display: "flex",
									alignItems: "center",
									gap: "16px",
								}}
							>
								<div className="integrations-search">
									{/* <Image src={searchIcon} alt="Search Icon" className="icon" /> */}
									<input placeholder="Search" onChange={handleSearch} />
								</div>
							</div>




							<button className="add-btn" onClick={()=>handleOpenModal1('new', null)} style={{ cursor: "pointer" }}>
								Add New Partner
							</button>
						</Stack>
					</Stack>



					<Grid
						container
						spacing={2}
						style={
							{
								position: "relative",
								// height: "calc(100vh - 150px)",
								// overflowY: "auto",
								// scrollbarWidth: "none",
								"-ms-overflow-style": "none",
								"&::-webkit-scrollbar": {
									display: "none",
								},
							} as any
						}
					>
						{setData.length === 0 ? (
							<Box
								style={{ marginInline: "auto" }}
								display="flex"
								alignItems="center"
								flexDirection="column"
								sx={{
									height: "74vh",
									display: "grid",
									placeContent: "center",
								}}
							>

								<Image
								// src={createNewDashboard}
								// alt="Create New"
								// style={{ cursor: "pointer", margin: "auto" }}
								/>

								<Typography
									textAlign="center"
									sx={{
										fontSize: "16px",
										fontWeight: 400,
										lineHeight: "19px",
										marginTop: "10px",
									}}
								>
									
									<Box display="flex" flexDirection="column" alignItems="center" gap={1}>
										<CircularProgress color="info" size={44} />
										<span>Loading...</span>
									</Box>
								</Typography>
							</Box>
						) : (
							""
						)}
						{setData.filter((user) => user.centralUser.name.toLowerCase().includes(search.toLowerCase())).map((user: any, index: number) => (
							<Grid item xs={12} sm={6} md={4} lg={3} key={user.centralUser.userId}>
								<Card
									className="userCard"
									style={{
										opacity: user.centralUser.accountStatus === "ACTIVE" ? "1" : "0.4",
									}}
								>
									<Stack display="flex" flexDirection="row" alignItems="start">

										<Box style={{ width: "100%" }}>
											<Stack
												display="flex"
												flexDirection="row"
												alignItems="start"
												justifyContent="space-between"
												style={{ marginBottom: "20px", position: "relative" }}
											>
												<Stack
													display="flex"
													flexDirection="row"
													alignItems="start"
													gap="8px"
												>
													{user.centralUser.profilePhoto ? (
														<Image
															src={user.centralUser.profilePhoto}
															alt="partner"
															className="icon"
															height={52}
															width={52}
														/>
													) : (
														<ProfileAvatar
															key={index}
															firstName={user.centralUser.name}
															lastName={user.centralUser.lastName !== undefined ? user.centralUser.lastName : ""}
														/>
													)}
													<div>
														<Typography className="userName">
															<div
																style={{
																	overflow: "hidden",
																	textOverflow: "ellipsis",
																	whiteSpace: "nowrap",
																	maxWidth: "130px"
																}}
																title={`${user.centralUser.name} ${user.centralUser.lastName !== undefined ? user.centralUser.lastName : ""}`}
															>
																{`${user.centralUser.name} ${user.centralUser.lastName !== undefined ? user.centralUser.lastName : ""}`}
															</div>
														</Typography>
														<span className="bottom-box">
															Partner
														</span>
													</div>
												</Stack>

												<Stack flexDirection="row">
													<Box
														sx={{
															display: "flex",
															flexDirection: "row",
															alignItems: "center",
															paddingRight: "19px",
															borderRight: user.centralUser.accountStatus === "ACTIVE" ? "1px solid #313838" : undefined,
															margin: "3px 0px",
															opacity: user.centralUser.accountStatus === "ACTIVE" ? 1 : 1,
														}}
													>
														{/* <InfoHoverTooltip
															title={user.centralUser.accountStatus === "ACTIVE" ? TOOLTIP_TEXT.STATUS_SUSPEND : TOOLTIP_TEXT.STATUS_ACTIVE}
															arrowDirection="bottom"
														> */}
														<FormControlLabel
															control={
																<AntSwitch
																	checked={
																		user.centralUser.accountStatus === "ACTIVE"
																			? true
																			: false
																	}
																	onClick={handleChangeSwitch(
																		user.centralUser.userId,
																		user.centralUser.accountStatus === "ACTIVE"
																			? "suspend"
																			: "activate"
																	)}
																	inputProps={{ "aria-label": "ant design" }}
																/>
															}
															labelPlacement="start"
															label={<Typography> </Typography>}
														/>
													</Box>
													<Image
														src={'/icons/edit-blue-icon.svg'}
														alt="Edit User"
														onClick={() => handleOpenModal1('edit', user)}
														style={{
															marginLeft: "5px", width: "20px", cursor: "pointer",
														}}
													/>

													<div className="vertical-divider"
														style={{
															borderRight: user.centralUser.accountStatus === "ACTIVE" ? "1px solid #313838" : undefined,
															paddingRight: user.centralUser.accountStatus === "ACTIVE" ? "5px" : undefined,
															height: "16px",
															marginTop: "3px",
														}}
													/>

													<InfoHoverTooltip title="Download license key" arrowDirection="bottom">
														<DownloadIcon
															sx={{
																color: "#17b2eb !important",
																fontSize: 24,
																stroke: "#17b2eb",
																fill: "#17b2eb",
																marginLeft: user.centralUser.accountStatus === "ACTIVE" ? "5px" : "10px",
																marginTop: "2px",
																width: "20px",
																height: "20px",
																cursor: "pointer",
																
															}}
															onClick={() => downloadLicense(user?.userId)}
														/>
													</InfoHoverTooltip>
													{/* {user.centralUser.accountStatus === "ACTIVE" && (
														<Image
															className="icon"
															src={optionIcon}
															alt="options"
															onClick={() => handleToggleDropdown(user.centralUser.userId)}
														/>
													)} */}
												</Stack>

												{/* {dropdownVisible === user.centralUser.userId && (
													<ClickAwayListener onClickAway={() => setDropdownVisible(null)}>
														<div className="cardDropdown" style={{ top: '20px', maxWidth: '200px !important' }}>
															<Stack
																display="flex"
																flexDirection="row"
																alignItems="center"
																gap="4px"
																style={{
																	padding: "8px",
																	cursor: "pointer",
																}}
																onClick={() => {
																	handleOpenModal2(user.centralUser.userId);
																}}
															>
																<Image src={editIcon} alt="edit Icon" />
																<Typography>Edit</Typography>
															</Stack>
															<Stack
																display="flex"
																flexDirection="row"
																alignItems="center"
																gap="4px"
																style={{
																	padding: "8px",
																	cursor: "pointer",
																}}
																onClick={() =>
																	handleDropdownOptionClick(user.centralUser.userId)
																}
															>
																<Image src={deleteIcon} alt="delete Icon" />
																<Typography>Delete</Typography>
															</Stack>
														</div>
													</ClickAwayListener>
												)} */}
											</Stack>
											<div className="userDetails" style={{ marginLeft: '58px' }}>
												<Image src={phoneIcon} alt="phone" />
												<div>{user.centralUser.mobile}</div>
											</div>
											<div className="userDetails" style={{ marginLeft: '58px' }}>
												<Image src={mailIcon} alt="mail" />
												<div
													style={{
														whiteSpace: "nowrap",
														overflow: "hidden",
														textOverflow: "ellipsis",
														maxWidth: "150px",
														cursor: "pointer",
													}}
													title={user.centralUser.mailId}
												>{user.centralUser.mailId}</div>
											</div>


										</Box>
									</Stack>
								</Card>
							</Grid>
						))}
					</Grid>
				</Box>
			</Box>






			<Modal
				aria-labelledby="transition-modal-title"
				aria-describedby="transition-modal-description"
				open={openModal1}
				onClose={handleCloseModal}
				closeAfterTransition
				BackdropComponent={Backdrop}
				BackdropProps={{
					timeout: 500,
				}}
				className="customMuiModal"
			>
				<Fade in={openModal1}>
					<Box sx={styleModal}>
						<Stack
							display="flex"
							flexDirection="row"
							alignItems="center"
							justifyContent="space-between"
							marginBottom={5}
							style={{ borderBottom: "1px solid #5A5F60", paddingBottom: "15px" }}
						>
							<Typography className="modalHeading">{actionType === "new" ? "Add New Partner" : `Edit Partner - ${selectedUser?.centralUser?.name} ${selectedUser?.centralUser?.lastName}`}</Typography>
							<Image
								src={closeIcon}
								alt="close icon"
								onClick={handleCloseModal}
								className="icon"
							/>
						</Stack>
						{/* <div style={{textAlign:'center',color:'red'}}>{errors}</div> */}
						<Box>
							<div>
								<div>
									<form
										style={
											{
												overflowY: "auto",
												scrollbarWidth: "none",
												"-ms-overflow-style": "none",
												"&::-webkit-scrollbar": {
													display: "none",
												},
											} as any
										}
									>
										<Stack
											display="flex"
											flexDirection="row"
											alignItems="center"
											gap="16px"
											style={{}}
										>
											<div style={{ width: "50%", position: "relative", paddingBottom: "20px" }}>
												<label
													htmlFor="firstName"
													className="modalForm-label"
												>
													First Name
												</label>
												<br />
												<input
													type="text"
													id="firstName"
													placeholder="Enter First Name"
													className="modalForm-input"
													name="name"
													value={formData.name}
													onChange={handleChange}
													autoComplete="off"
												/>
											</div>
											<div style={{ width: "50%", paddingBottom: "20px" }}>
												<label
													htmlFor="lastName"
													className="modalForm-label"
												>
													Last Name
												</label>
												<br />
												<input
													type="text"
													id="lastName"
													placeholder="Enter Last Name "
													name="lastName"
													className="modalForm-input"
													value={formData.lastName}
													onChange={handleChange}
													autoComplete="off"
												/>
												{/* {errors.lastName && <div className="error-message">{errors.lastName}</div>} */}
											</div>
										</Stack>
										{(errors.name || errors.lastName) && (
											<div className="error-message" style={{ marginTop: "-20px" }}>
												First and last name can't be empty
											</div>
										)}
										{/* {errors.name && !errors.lastName && <div className="error-message">{errors.name}</div>}
                        {!errors.name && errors.lastName && <div className="error-message">{errors.lastName}</div>} */}

										<div style={{ paddingBottom: "20px" }}>
											<label htmlFor="emailId" className="modalForm-label">
												Email ID
											</label>
											<br />
											<input
												type="email"
												id="emailId"
												name="mailId"
												placeholder="Enter Email ID "
												className="modalForm-input"
												value={formData.mailId}
												onChange={handleChange}
												autoComplete="off"
											/>
											{errors.mailId && (
												<div className="error-message">{errors.mailId}</div>
											)}
										</div>
										<div style={{ paddingBottom: "20px" }}>
											<label htmlFor="contact" className="modalForm-label">
												Mobile Number
											</label>
											<br />
											<PhoneInput
												//country={'us'}
												placeholder="Enter mobile numnber"
												specialLabel=""
												dropdownClass="user-phone-input-dropdown"
												containerClass="user-phone-input-container"
												inputClass="modalForm-input user-phone-input"
												inputStyle={{
													boxShadow: 'none',
													color: "#fff",
													border: "1px solid #313838 !important",
													width: "100%",
													height: "40px",
													backgroundColor: "#192529",
												}}
												value={formData.mobile}
												onChange={(number) => {handleNumber(number, "create"); validateMobileNumber(number);}}
												enableLongNumbers={true}
											/>
											{(partnerMobileNumber) && (
												<div className="error-message">{partnerMobileNumber}</div>
											)}
										</div>
										{actionType === "new" && <div>
											<label htmlFor="emailMessage" className="modalForm-label">
												Email Message
											</label>
											<br />
											<input
												type="email"
												id="emailMessage"
												name="emailMessage"
												placeholder="Enter Email Message "
												className="modalForm-input"
												value={formData.emailMessage}
												onChange={handleChange}
												autoComplete="off"
											/>
											{errors.emailMessage && (
												<div className="error-message">{errors.emailMessage}</div>
											)}
										</div>}
									</form>
								</div>

								<div>
									<Stack
										display="flex"
										flexDirection="row"
										alignItems="center"
										justifyContent="flex-end"
										gap="12px"
										style={{ marginTop: "20px" }}
									>
										<button
											type="button"
											className="outline-btn hoverBtn"
											onClick={handleCloseModal}
											style={{ padding: "11px 10px", border: "1px solid #17b2eb", borderRadius: "30px", cursor: "pointer", color: "#fff" }}
										>
											Cancel
										</button>
										<button
											type="button"
											className="add-btn save-btn"
											onClick={(e) => handleSubmit(e, "user")}
											style={{ cursor: "pointer" }}
										>
											{actionType === "new" ? "Save" : "Update"}
										</button>
									</Stack>
								</div>
							</div>
						</Box>
					</Box>
				</Fade>
			</Modal>



		</>
	);
};

export default UserManagement;
